import { z } from 'zod';

export const retryUploadResponseSchema = z.object({
  retried: z.boolean(),
  jobId: z.number(),
  clipId: z.number(),
});

export type IRetryUploadResponse = z.infer<typeof retryUploadResponseSchema>;
